import listActions from 'src/modules/nivelPrioridad/list/nivelPrioridadListActions';
import NivelPrioridadService from 'src/modules/nivelPrioridad/nivelPrioridadService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'NIVELPRIORIDAD_DESTROY';

const nivelPrioridadDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: nivelPrioridadDestroyActions.DESTROY_STARTED,
      });

      await NivelPrioridadService.destroyAll([id]);

      dispatch({
        type: nivelPrioridadDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.nivelPrioridad.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/nivel-prioridad');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: nivelPrioridadDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: nivelPrioridadDestroyActions.DESTROY_ALL_STARTED,
      });

      await NivelPrioridadService.destroyAll(ids);

      dispatch({
        type: nivelPrioridadDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.nivelPrioridad.destroyAll.success'),
      );

      getHistory().push('/nivel-prioridad');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: nivelPrioridadDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default nivelPrioridadDestroyActions;
